import React from 'react';
import envConfig from '@nile/home/src/Config/env';
import { BackgroundIcon } from '@nile/components';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button } from '@superops/ui-design-system';

const EmptyState = styled.div`
  .empty-message {
    max-width: 345px;
  }
`;

const Description = styled.span`
  color: #000000;
  opacity: 0.6;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin: 6px auto;
  text-align: center;
`;

const StyledConversation = styled.div`
  overflow: auto;
  align-content: start;
  height: calc(100% - 8px);

  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;

  .rdw-editor-wrapper {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
    border: 1px solid #ececec;
  }
  .action-buttons .Polaris-Button--plain {
    margin-left: auto;
  }
`;

const EmptyTabState = (props) => {
  const { iconName, title, description } = props;
  return (
    <StyledConversation className="fx fcol g15 full-width full-height p12">
      <EmptyState className="full-width full-height flex actr jctr">
        <div className="fx col actr g15">
          {/* Illustration images hence not changed to SVG */}
          <BackgroundIcon
            url={`url(${envConfig.imageRoot}svg/${iconName}.svg)`}
            height="120px"
            width="120px"
          />
          <div className="empty-message tcenter grid mw-300 font-weight-500">
            {title && (
              <FormattedMessage
                id={title || 'ticket.details.sideConversation.emptyState'}
              />
            )}
            {description && (
              <Description className="empty-description">
                <FormattedMessage
                  id={
                    description ||
                    'ticket.details.sideConversation.emptyState.description'
                  }
                />
              </Description>
            )}
            {props?.button && props?.button?.text && (
              <Button onClick={props.button?.onClick} primary>
                {props.button?.text}
              </Button>
            )}
          </div>
        </div>
      </EmptyState>
    </StyledConversation>
  );
};

export default EmptyTabState;
